import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const CANDIDATE_STATUS_STYLES = {
    initialized:            { bg: "gray.800",   borderColor: "gray.600",   color: "gray.400" },
    created:                { bg: "blue.900",   borderColor: "blue.700",   color: "blue.300" },
    finalized:              { bg: "orange.900", borderColor: "orange.700", color: "orange.300" },
    qualifiedfornextstage:  { bg: "purple.900", borderColor: "purple.700", color: "purple.300" },
    furtherselection:       { bg: "cyan.900",   borderColor: "cyan.700",   color: "cyan.300" },
    readytohire:            { bg: "teal.900",   borderColor: "teal.700",   color: "teal.300" },
    hired:                  { bg: "green.900",  borderColor: "green.700",  color: "green.300" },
    rejected:               { bg: "red.900",    borderColor: "red.700",    color: "red.300" },
    candidateresigned:      { bg: "gray.800",   borderColor: "gray.600",   color: "gray.400" },
};

const DEFAULT_STYLE = { bg: "gray.800", borderColor: "gray.600", color: "gray.400" };

const CandidateStatusBadge = ({ status }) => {
    const { t } = useTranslation("models");
    const key = status?.toLowerCase() ?? "initialized";
    const style = CANDIDATE_STATUS_STYLES[key] ?? DEFAULT_STYLE;
    return (
        <Badge
            bg={style.bg}
            borderColor={style.borderColor}
            borderWidth={1}
            variant="subtle"
            fontSize="xs"
            px={3}
            py={0.5}
            borderRadius={6}
            color={style.color}
        >
            {t(`candidateStatus.${key}`)}
        </Badge>
    );
};

export default CandidateStatusBadge;
